import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { TipsAndUpdatesIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

type TaskTipProps = Readonly<{
	reasoning: string;
	isCompleted: boolean;
}>;

export const TaskTip: React.FC<TaskTipProps> = ({ reasoning, isCompleted }) => {
	return (
		<div className="flex items-start gap-2 pl-2" data-qa="dynamic-task-tip">
			<TipsAndUpdatesIcon size={19} className="text-typography-weak shrink-0" />
			<Text
				variant="body"
				size="small"
				className={cn('m-0 min-w-0 flex-1', isCompleted && 'text-typography-weak')}
				as="p"
			>
				<Text variant="body" size="small" fontWeight="bold" as="span">
					<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.tip.label" />
				</Text>
				<Text variant="body" size="small" as="span">
					{reasoning}
				</Text>
			</Text>
		</div>
	);
};
